import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { styled, Tooltip } from '@mui/material'
import Grid from '@mui/material/Grid2'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import Typography from '@mui/material/Typography'
import { map } from 'lodash'
import { FC, useEffect, useMemo } from 'react'
import FolderIcon from '../../assets/icons/Folder.svg?react'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import { useWrapperStore } from '../../store/storeWrapper'

export const StyledSelect = styled(Select)<{ disabled: boolean }>(({ disabled }) => ({
    mr: 1,
    overflow: 'auto',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #E5E5E7',
    '&:hover': {
        border: '1px solid #E5E5E7',
    },
    '& .MuiSelect-select': {
        background: disabled? '#E5E5E7' : '#fff',
        padding: '8px 48px 8px 16px !important',
    },
    '& .MuiSelect-select:hover': {
        background:  disabled? '#E5E5E7' : '#F6F6F6',
    },
    '& .MuiSelect-icon': {
        marginRight: '12px',
        fontSize: ' 20px',
        color: '#1B1C1D',
    },
}))

type Props = {
    id?: string
    handleChange: (name: string, value?: string) => void
}

export const ProjectSelect: FC<Props> = ({ id, handleChange }) => {
    const [_, setCurrentProjectId] = useLocalStorage('currentProjectId', null)
    const { projectListActive, stepOnboarding } = useWrapperStore((state) => state)

    useEffect(() => {
        if (id) {
            setCurrentProjectId(id)
        }
    }, [id])

    const options = useMemo(
        () => [
            {
                key: 'empty-project-option',
                value: '',
                title: 'Без проекта',
            },
            ...(projectListActive?.map(({ id, title }) => ({ key: id, value: id, title })) ?? []),
        ],
        [projectListActive],
    )

    const handleChangeValue = (event: SelectChangeEvent<unknown>) => {
        const {
            target: { name, value },
        } = event

        handleChange(name, `${value}` || undefined)
    }

    return (
        <Tooltip
            title={stepOnboarding !== 100 ? '' : 'Выбор проекта для запроса'}
            placement="bottom"
            slotProps={{
                tooltip: {
                    sx: {
                        maxWidth: '150px',
                    },
                },
            }}>
            <StyledSelect
                disabled={stepOnboarding !== 100}
                IconComponent={KeyboardArrowDownIcon}
                MenuProps={{
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'right',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    },
                }}
                id="workplaceId"
                name="workplaceId"
                value={id ?? ''}
                displayEmpty
                onChange={handleChangeValue}
                color="secondary">
                {map(options, (item) => {
                    const { title, key, value } = item
                    return (
                        <MenuItem
                            value={value}
                            key={key}
                            sx={{
                                borderBottom: '1px solid #F4F4F6',
                                p: '10px 16px',
                            }}>
                            <Grid
                                container
                                sx={{
                                    width: '100%',
                                    m: 0,
                                    alignItems: 'center',
                                    flexWrap: 'nowrap',
                                }}>
                                <FolderIcon
                                    color="#5A5F72"
                                    style={{
                                        marginRight: '8px',
                                    }}
                                />

                                <Typography
                                    sx={{
                                        maxWidth: '128px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        fontSize: '12px',
                                    }}
                                    variant="h6">
                                    {title}
                                </Typography>
                            </Grid>
                        </MenuItem>
                    )
                })}
            </StyledSelect>
        </Tooltip>
    )
}
